module.exports = __webpack_public_path__ + "static/media/video.20b4c709.webm";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/video.webm
// module id = 203
// module chunks = 0